<template>
  <div id="app">
    <a-locale-provider :locale="zh_CN">
      <router-view></router-view>
    </a-locale-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
export default {
  data(){
    return {
      zh_CN
    }
  },
  name: "app",
  components: {}
};
</script>

<style>
#app.bodyLock{
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  overflow: hidden;
}
</style>
